import axios from 'axios'

// initial state
const state = () => ({
  ICDO3H: [],
  ICDO3T: []
})

// getters
const getters = {
  ICDO3H: ({ ICDO3H }) => ICDO3H,
  ICDO3T: ({ ICDO3T }) => ICDO3T,
}

// actions
const actions = {
    async getICDO3H({ commit }, diagnosis_id) {
      const icd = (await axios.get('/meta/diagnosis/icdo3h?diagnosis_id=' + diagnosis_id)).data
      commit('setICDO3H', icd)
    },
    async getICDO3T({ commit }, diagnosis_id) {
      const icd = (await axios.get('/meta/diagnosis/icdo3t?diagnosis_id=' + diagnosis_id)).data
      commit('setICDO3T', icd)
    }
}

// mutations
const mutations = {
  setICDO3H(state, ICDO3H) {
    state.ICDO3H = ICDO3H
  },
  setICDO3T(state, ICDO3T) {
    state.ICDO3T = ICDO3T
  }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
